import React from "react";

import { useFela } from "react-fela";
import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { Icon, StyledIconWrapper } from "@/components/Icon";
import { IIconType } from "@/icons";

interface IPricingTab {
  isActive: boolean;
  title: string;
  subtitle: string;
  icon: IIconType;
  onClick: () => void;
}

export const PricingTab = ({
  isActive,
  title,
  subtitle,
  icon,
  onClick,
}: IPricingTab) => {
  const { css } = useFela();
  const { colors } = useTheme();

  return (
    <div
      className={css({
        width: 320,
        display: "flex",
        alignItems: "center",
        padding: "12px 20px",
        backgroundColor: isActive ? colors.GHOST_WHITE : "#3A1F84",
        borderRadius: "8px 8px 0px 0px",
        nested: {
          ":hover": {
            cursor: "pointer",
          },
        },
      })}
      onClick={onClick}
      role="button"
    >
      <StyledIconWrapper
        customStyle={{
          nested: {
            "> *": { stroke: isActive ? colors.DARK_GREY : colors.WHITE },
          },
        }}
      >
        <Icon iconType={icon} />
      </StyledIconWrapper>
      <div className={css({ marginLeft: 16 })}>
        <Heading
          as="h4"
          customStyle={{
            color: isActive ? colors.DARK_GREY : colors.GHOST_WHITE,
          }}
        >
          {title}
        </Heading>
        <p
          className={css({
            marginTop: 2,
            fontSize: 12,
            color: isActive ? colors.LIGHT_GRAY : colors.WHITE,
            letterSpacing: "0.25px",
          })}
        >
          {subtitle}
        </p>
      </div>
    </div>
  );
};
